import { Container } from "@components/ui/Container";
import { Trans } from "@helpers/translate";
import React from "react";

const IconBrush = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1024"
    viewBox="0 0 768 768"
    height="1024"
    version="1.0"
    className="w-12 h-12 text-red-600"
  >
    <defs>
      <clipPath id="a">
        <path d="M64.766 61.203h636v641.25h-636Zm0 0" />
      </clipPath>
    </defs>
    <path
      fill="#d50f16"
      d="M663.305 105.281c-14.114-14.117-32.88-21.89-52.844-21.89-19.965 0-38.719 7.773-52.844 21.89-.36.36-.707.73-1.031 1.117-.824.965-82.766 96.375-112.406 124.723-1.227 1.172-2.746 2.469-4.532 3.895l-51.347-51.348c-13.996-14-32.613-21.711-52.418-21.711-19.797 0-38.418 7.711-52.414 21.711-14.004 14.008-21.723 32.625-21.723 52.422 0 2.445.121 4.879.36 7.281L90.597 387.152a20.03 20.03 0 0 0-7.157 14.504 20.08 20.08 0 0 0 5.852 15.074l262.539 262.555a20.1 20.1 0 0 0 15.078 5.863 20.1 20.1 0 0 0 14.504-7.156L525.21 506.465a78 78 0 0 0 7.273.351c19.801 0 38.414-7.71 52.414-21.71 28.895-28.895 28.895-75.93 0-104.836l-51.343-51.36c1.43-1.789 2.726-3.308 3.894-4.531 28.336-29.625 123.758-111.559 124.711-112.383q.586-.498 1.125-1.031c14.121-14.113 21.899-32.887 21.899-52.852.011-19.965-7.766-38.734-21.88-52.832M364.738 635.387 133.195 403.836l52.684-44.164c3.7 4.879 4.121 9.36 4.746 17.015.984 12.02 2.348 28.481 18.996 45.125 16.649 16.649 33.113 18 45.14 18.997 9.188.757 13.802 1.14 20.028 7.37 6.227 6.223 6.602 10.829 7.356 20.009.984 12.019 2.335 28.484 18.976 45.12 16.64 16.637 33.098 17.985 45.113 18.965 9.18.743 13.786 1.125 19.989 7.336 6.214 6.22 6.59 10.825 7.34 19.996.964 11.735 2.37 27.688 17.894 43.922Zm52.852-63.043c-3.035-4.508-3.43-8.875-4.012-16.004-.984-12.02-2.332-28.477-18.976-45.117-16.63-16.641-33.086-17.993-45.106-18.97-9.172-.745-13.777-1.12-19.992-7.339-6.223-6.223-6.594-10.828-7.352-20.004-.984-12.02-2.336-28.48-18.98-45.117-16.64-16.652-33.106-18.004-45.125-18.996-9.188-.754-13.809-1.137-20.043-7.379-6.23-6.234-6.613-10.836-7.371-20.023-.875-10.668-2.098-24.836-13.985-39.528l61.395-51.465c1.691 2.114 3.488 4.164 5.434 6.106l196.601 196.597c1.938 1.946 3.988 3.735 6.094 5.43Zm217.789-390.27c-9.234 7.934-98.184 84.485-126.945 114.559-5.235 5.472-10.188 12.21-17.051 21.55l-.52.696c-5.875 7.984-5.039 19.07 1.98 26.086l63.665 63.68c13.246 13.253 13.254 34.816.008 48.07-6.414 6.41-14.95 9.941-24.024 9.941-9.078 0-17.61-3.531-24.027-9.941L311.867 260.109c-6.418-6.421-9.957-14.949-9.957-24.027 0-9.066 3.54-17.61 9.957-24.031 6.41-6.414 14.942-9.946 24.024-9.946s17.609 3.532 24.02 9.946l63.671 63.68c7.012 7.023 18.113 7.863 26.09 1.976l.976-.707c9.22-6.79 15.883-11.687 21.297-16.871C502 231.383 578.56 142.437 586.5 133.187c6.477-6.23 14.957-9.652 23.96-9.652 9.235 0 17.919 3.602 24.45 10.137 6.531 6.527 10.125 15.2 10.125 24.437 0 9.016-3.418 17.496-9.656 23.965m0 0"
    />
    <g clipPath="url(#a)">
      <path
        fill="none"
        d="M663.309 105.281c-14.114-14.117-32.88-21.89-52.844-21.89-19.961 0-38.719 7.773-52.844 21.89-.36.36-.707.73-1.031 1.117-.824.965-82.766 96.375-112.406 124.723-1.223 1.172-2.747 2.469-4.532 3.895l-51.347-51.348c-13.996-14-32.618-21.711-52.422-21.711-19.797 0-38.418 7.711-52.414 21.711-14.004 14.008-21.723 32.625-21.723 52.422 0 2.445.121 4.879.36 7.281L90.597 387.156a20.03 20.03 0 0 0-7.157 14.504 20.1 20.1 0 0 0 5.852 15.078l262.54 262.552a20.1 20.1 0 0 0 15.078 5.863 20.1 20.1 0 0 0 14.508-7.156L525.215 506.47a78 78 0 0 0 7.273.351c19.801 0 38.414-7.71 52.414-21.71 28.895-28.895 28.895-75.93 0-104.837L533.56 328.91c1.43-1.789 2.726-3.308 3.894-4.531 28.336-29.625 123.758-111.559 124.711-112.383q.586-.498 1.125-1.031c14.121-14.113 21.898-32.887 21.898-52.852.012-19.965-7.765-38.734-21.878-52.832Zm-298.57 530.113L133.194 403.84l52.684-44.164c3.7 4.879 4.121 9.36 4.746 17.015.984 12.02 2.348 28.48 18.996 45.125 16.649 16.649 33.113 18 45.14 18.996 9.188.758 13.801 1.141 20.028 7.372 6.227 6.222 6.602 10.828 7.356 20.007.984 12.02 2.335 28.485 18.98 45.121 16.637 16.637 33.094 17.985 45.11 18.965 9.179.742 13.785 1.125 19.988 7.336 6.214 6.219 6.593 10.824 7.34 19.996.968 11.735 2.374 27.688 17.898 43.922Zm52.855-63.046c-3.035-4.508-3.43-8.875-4.012-16.004-.984-12.02-2.332-28.477-18.977-45.117-16.628-16.641-33.09-17.993-45.109-18.97-9.172-.745-13.777-1.12-19.992-7.34-6.223-6.222-6.594-10.827-7.352-20.003-.984-12.02-2.336-28.48-18.98-45.117-16.64-16.652-33.106-18.004-45.125-18.996-9.188-.754-13.809-1.137-20.043-7.38-6.23-6.23-6.613-10.835-7.371-20.023-.875-10.668-2.098-24.836-13.985-39.53l61.395-51.466c1.691 2.114 3.488 4.164 5.434 6.106l196.605 196.601c1.937 1.946 3.988 3.735 6.094 5.43Zm217.789-390.274c-9.235 7.934-98.184 84.485-126.946 114.559-5.234 5.472-10.187 12.21-17.05 21.55l-.52.696c-5.875 7.984-5.039 19.07 1.98 26.09l63.665 63.68c13.246 13.253 13.254 34.816.007 48.07-6.414 6.41-14.949 9.941-24.023 9.941-9.078 0-17.61-3.531-24.027-9.941l-196.602-196.61c-6.418-6.422-9.957-14.949-9.957-24.027 0-9.066 3.54-17.61 9.957-24.031 6.41-6.414 14.942-9.946 24.024-9.946s17.609 3.532 24.02 9.946l63.675 63.68c7.012 7.023 18.113 7.863 26.09 1.976l.976-.707c9.22-6.79 15.883-11.688 21.297-16.871 30.055-28.746 106.613-117.692 114.555-126.942 6.476-6.23 14.957-9.652 23.96-9.652 9.235 0 17.919 3.602 24.45 10.137 6.531 6.527 10.125 15.2 10.125 24.437 0 9.016-3.418 17.496-9.656 23.965Zm0 0"
        stroke="#d50f16"
        strokeWidth="11.25"
      />
    </g>
  </svg>
);

const IconPeople = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1024"
    viewBox="0 0 768 768"
    height="1024"
    version="1.0"
    className="w-12 h-12 text-red-600"
  >
    <defs>
      <clipPath id="a">
        <path d="M66 316h636v384H66Zm0 0" />
      </clipPath>
    </defs>
    <path
      fill="#d50f16"
      d="M252.621 364.75c62.984 0 114.227-51.242 114.227-114.227 0-62.984-51.239-114.226-114.227-114.226-62.984 0-114.223 51.242-114.223 114.226S189.637 364.75 252.621 364.75Zm0-186.125c39.645 0 71.899 32.254 71.899 71.895 0 39.644-32.254 71.898-71.899 71.898-39.644 0-71.894-32.254-71.894-71.898 0-39.641 32.25-71.895 71.894-71.895ZM515.379 364.75c62.984 0 114.223-51.242 114.223-114.227 0-62.984-51.239-114.226-114.223-114.226s-114.227 51.242-114.227 114.226S452.395 364.75 515.38 364.75Zm0-186.125c39.644 0 71.894 32.254 71.894 71.895 0 39.644-32.253 71.898-71.894 71.898-39.645 0-71.899-32.254-71.899-71.898 0-39.641 32.254-71.895 71.899-71.895Zm0 0"
      stroke="#d50f16"
      strokeWidth="12"
    />
    <path
      fill="#d50f16"
      d="M383.996 447.578C285.16 324.468 84 394.25 84 553.352v57.187c0 11.688 9.477 21.164 21.164 21.164h557.672c11.687 0 21.164-9.476 21.164-21.164v-57.187c0-159.149-201.3-228.778-300.004-105.774m-5.09 141.793H126.328v-36.02c0-69.632 56.656-126.28 126.297-126.28 70.297 0 126.281 56.874 126.281 126.28Zm262.766 0H421.234c0-39.555 2.52-64.543-13.476-102.16 22.918-37.34 63.293-60.14 107.617-60.14 69.64 0 126.293 56.648 126.293 126.28v36.02Zm0 0"
    />
    <g clipPath="url(#a)">
      <path
        fill="none"
        d="M383.996 447.578C285.16 324.468 84 394.25 84 553.352v57.187c0 11.688 9.477 21.164 21.164 21.164h557.672c11.687 0 21.164-9.476 21.164-21.164v-57.187c0-159.149-201.3-228.778-300.004-105.774Zm-5.09 141.793H126.328v-36.02c0-69.632 56.656-126.28 126.297-126.28 70.297 0 126.281 56.874 126.281 126.28Zm262.766 0H421.234c0-39.555 2.52-64.543-13.476-102.16 22.918-37.34 63.293-60.14 107.617-60.14 69.64 0 126.293 56.648 126.293 126.28v36.02Zm0 0"
        stroke="#d50f16"
        strokeWidth="12"
      />
    </g>
  </svg>
);

const IconCheck = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1024"
    viewBox="0 0 768 768"
    height="1024"
    version="1.0"
    className="w-12 h-12 text-red-600"
  >
    <path
      strokeLinecap="round"
      fill="none"
      strokeLinejoin="round"
      d="m301.031 370.918 55.313 55.312 124.453-124.453m124.453 82.97c0 135.75-148.07 234.48-201.945 265.91-6.125 3.573-9.184 5.359-13.504 6.284-3.356.72-8.246.72-11.602 0-4.32-.925-7.379-2.71-13.504-6.285-53.875-31.43-201.945-130.16-201.945-265.91V252.484c0-22.113 0-33.168 3.617-42.671a55.3 55.3 0 0 1 15.125-21.825c7.63-6.722 17.98-10.605 38.684-18.37l148.285-55.606c5.75-2.157 8.625-3.235 11.586-3.664a27.6 27.6 0 0 1 7.906 0c2.961.43 5.836 1.507 11.586 3.664l148.285 55.605c20.703 7.766 31.055 11.649 38.684 18.371a55.3 55.3 0 0 1 15.125 21.825c3.617 9.503 3.617 20.558 3.617 42.671Zm0 0"
      stroke="#d50f16"
      strokeWidth="66.375"
    />
  </svg>
);

const Stats = () => (
  <div className="bg-gray-100 py-8">
    <Container className="py-0">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        <div className="flex items-center w-full mb-6 lg:mb-0">
          <div className="mr-4">
            <IconBrush />
          </div>
          <div>
            <h3 className="text-lg font-bold">
              <Trans id="home.stats.0.title">All Tours Customizable</Trans>
            </h3>
            <p className="text-base text-gray-600">
              <Trans id="home.stats.0.description">
                Start By Messaging Your Guide
              </Trans>
            </p>
          </div>
        </div>
        <div className="flex items-center w-full mb-6 lg:mb-0 lg:justify-center">
          <div className="mr-4">
            <IconPeople />
          </div>
          <div>
            <h3 className="text-lg font-bold">
              <Trans id="home.stats.1.title">100% Private Tours</Trans>
            </h3>
            <p className="text-base text-gray-600">
              <Trans id="home.stats.1.description">
                Just You and Your Local Tour Guide
              </Trans>
            </p>
          </div>
        </div>
        <div className="flex items-center w-full lg:justify-end">
          <div className="mr-4">
            <IconCheck />
          </div>
          <div>
            <h3 className="text-lg font-bold">
              <Trans id="home.stats.2.title">Quality Assured Guides</Trans>
            </h3>
            <p className="text-base text-gray-600">
              <Trans id="home.stats.2.description">
                Screened and Verified via Interviews
              </Trans>
            </p>
          </div>
        </div>
      </div>
    </Container>
  </div>
);

export default Stats;
